export default __webpack_public_path__ + "static/media/pictogramBeaconMarketplace128.68a33b12.svg";